//if user specialist is selected, autofill input field
$('.specialist-fee-select').change(function (e) {
    const element = $(this).find('option:selected');
    const feeRate = element.data("fee");
    element.closest('.fee-col').find('.specialist-fee-rate').val(feeRate);
});


//calculate and validate fee input
$('.specialist-fee-input').change(function () {
    calculateFee()
})

$(document).ready(function () {
    if (window.location.href.includes('contract')) {
        calculateFee();
    }
});

function calculateFee() {
    const first = parseFloat($('#first_specialist_fee').val()?.replace(",","."));
    const second = parseFloat($('#second_specialist_fee').val()?.replace(",","."));

    if (!first || first >= 100) {
        $("#secondFee").hide();
        $("#thirdFee").hide();
    } else {
        $("#secondFee").show();

        if ((first + second) >= 100 || !$("#second_specialist_fee").val()) {
            $("#thirdFee").hide();
        } else {
            $("#thirdFee").show();
        }
    }
}
